import * as types from './typeNames'
import axios from 'axios'
import qs from 'qs'
import LZString from 'lz-string'
import { baseURL } from './base'
import { changeView, LOADER_VIEW, FORM_SETTINGS_VIEW, FORM_LIST_VIEW } from './main'
import { setSettings, resetSettings } from './settings'
import { browserHistory } from 'react-router'



export const addNewForm = (form) =>({
    type: types.ADD_NEW_FORM,
    form
});

export const editForm = (formId, isPreview, fromEditor=null) => dispatch => {
    let url  = `${baseURL}/edit/${formId}`
    
    if(!isPreview){
        dispatch(changeView(LOADER_VIEW, true));
    }
    
    return axios.get(url)
            .then(response => {
                if(response.data.status === 'success'){
                    console.log("Result Create: ", response.data.data)
                    let config = {}
                    try{
                        config = JSON.parse(LZString.decompressFromBase64(response.data.data.Config));
                    }catch(e){
                        console.log("Error Parse Config: ", e)
                        config = {settings: null, design: null}
                    }
                    dispatch(setSettings(response.data.data, config, fromEditor))
                    dispatch(selectForm(response.data.data))
                }                   
                else{
                    console.log(response.data)
                    dispatch(()=>({type:"error", err: response.data.error}))
                } 
            })
            .catch(err => { console.log(err); dispatch(()=>({type:"error", err})) })
            .then(() => { 
                if(!isPreview){
                    dispatch(changeView(FORM_SETTINGS_VIEW, false));
                }                
            })
}

export const deleteForm = FormId => dispatch => {
    dispatch(changeView(LOADER_VIEW))
    return axios.delete(`${baseURL}/delete/${FormId}`)
        .then(response => {
            if(response.data.status === 'success'){
                dispatch(deleteFormSuccess(FormId))
            }else{
                console.log(response.data); dispatch(() => ({type: "error", err: response.data}))
            }
        })
        .catch(err => {console.log(err); dispatch(() => ({type: "error", err}))})
        .then(() => {console.log("Save Successful!"); dispatch(changeView(FORM_LIST_VIEW))})
}

const deleteFormSuccess = deletedFormId => ({
    type: types.DELETE_FORM,
    id: deletedFormId
})

export const duplicateForm = FormId => dispatch => {
    dispatch(changeView(LOADER_VIEW))
    return axios.get(`${baseURL}/duplicate/${FormId}`)
        .then( response => {
            if(response.data.status === 'success'){
                dispatch(duplicateFormSuccess(response.data.data))
            }else{
                console.log(response.data); dispatch(() => ({type: "error", err: response.data}))
            }
        })
        .catch(err => {console.log(err); dispatch(() => ({type: "error", err}))})
        .then(() => {console.log("Save Successful!"); dispatch(changeView(FORM_LIST_VIEW))})
}

const duplicateFormSuccess = (form) =>({
    type: types.DUPLICATE_FORM,
    form
});

const getFormListByUserIdSuccess = (forms) =>({
    type: types.GET_ALL_LIST,
    forms
});

export const getFormListByUserId = userId => dispatch =>{
    const url  = `${baseURL}/list`
    const data = {
        userid: userId
    }
    return axios.post(url, qs.stringify(data))
                .then(response => {
                    //console.log(response);
                    dispatch(getFormListByUserIdSuccess(response.data.data))
                    if(response.data.data.length === 0){
                        dispatch(createNewForm(userId))
                    }                    
                })
                .catch(err => { console.log(err); dispatch(()=>({type:"error", err})) })
                .then(()=>{console.log("Get List Request Finished!"); dispatch(changeView(FORM_LIST_VIEW))})
}


export const createNewForm = (userId) => (dispatch) => {
    const url  = `${baseURL}/create`
    dispatch(changeView(LOADER_VIEW, true));
    const data = {
        userid: userId
    }
    return axios.post(url, qs.stringify(data))
                .then(response => {
                    //console.log(response.data.status === 'success')
                    if(response.data.status === 'success'){
                        dispatch(resetSettings(response.data.data, {settings: null, design: null}))
                    }                   
                    else
                        console.log(response.data)

                    dispatch(changeView(FORM_SETTINGS_VIEW, false));
                    browserHistory.push(`/settings/${response.data.data.FormId}`)
                })
};

export const selectForm = form => ({
    type: types.SELECT_FORM,
    form
})

